module.exports = __webpack_public_path__ + "static/media/well_popup.e70d906d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/well_popup.png
// module id = 76
// module chunks = 0